import Vue from 'vue'
import VueRouter from 'vue-router'
import { CONSTANT } from '@/constants'
import "@/plugins/vue_stripe_plugins.js";

Vue.use(VueRouter)
const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('@/views/Home.vue'),
      meta: {
        pageTitle: 'Home',
        breadcrumb: [
          {
            text: 'Home',
            active: true,
          },
        ],
      },
    },
    {
      path: '/setting',
      name: 'setting',
      component: () => import('@/components/settings/main.vue'),
      meta: {
        pageTitle: 'CMS',
        breadcrumb: [
          {
            text: 'CMS',
            active: true,
          },
        ],
      },
    },
    {
      path: '/add-team',
      name: 'addTeam',
      component: () => import('@/components/settings/add-team-member.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/accept-team-invite',
      name: 'acceptTeamInvite',
      component: () => import('@/components/settings/accept-team-invite.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/groups',
      name: 'groups',
      component: () => import('@/views/Groups/Groups.vue'),
      meta: {
        pageTitle: 'Groups',
        breadcrumb: [
          {
            text: 'Groups',
            active: true,
          },
        ],
      },
    },
    {
      path: '/groups/:id',
      name: 'groups',
      component: () => import('@/views/Groups/ManageGroups.vue'),
      meta: {
        pageTitle: 'Manage Group',
        breadcrumb: [
          {
            text: 'Manage Group',
            active: true,
          },
        ],
      },
    },
    {
      path: '/groups/old',
      name: 'groups',
      component: () => import('@/views/old_Groups.vue'),
      meta: {
        pageTitle: 'Groups',
        breadcrumb: [
          {
            text: 'Groups',
            active: true,
          },
        ],
      },
    },
    {
      path: '/gamification',
      name: 'gamification',
      component: () => import('@/views/Gamification/Gamification.vue'),
      meta: {
        pageTitle: 'Gamification',
        breadcrumb: [
          {
            text: 'Gamification',
            active: true,
          },
        ],
      },
    },
    {
      path: '/gamification/:id',
      name: 'gamification',
      component: () => import('@/views/Gamification/Gamification.vue'),
      meta: {
        pageTitle: 'Gamification',
        breadcrumb: [
          {
            text: 'Gamification',
            active: true,
          },
        ],
      },
    },
    {
      path: '/gamifications/old',
      name: 'gamification',
      component: () => import('@/views/Gamification.vue'),
      meta: {
        pageTitle: 'Gamification',
        breadcrumb: [
          {
            text: 'Gamification',
            active: true,
          },
        ],
      },
    },
    {
      path: '/packages',
      name: 'packages',
      component: () => import('@/views/Packages/Packages.vue'),
      meta: {
        pageTitle: 'Packages',
        breadcrumb: [
          {
            text: 'Packages',
            active: true,
          },
        ],
      },
    },
    {
      path: '/packages/old',
      name: 'packages',
      component: () => import('@/views/Packages.vue'),
      meta: {
        pageTitle: 'Packages',
        breadcrumb: [
          {
            text: 'Packages',
            active: true,
          },
        ],
      },
    },
    {
      path: '/employee',
      name: 'addEmployee',
      component: () => import('@/views/Employee/Index.vue'),
      meta: {
        pageTitle: 'Employees',
        breadcrumb: [
          {
            text: 'Employees',
            active: true,
          },
        ],
      },
    },
    {
      path: '/employee/old',
      name: 'addEmployee',
      component: () => import('@/views/AddEmployee.vue'),
      meta: {
        pageTitle: 'Employees',
        breadcrumb: [
          {
            text: 'Employees',
            active: true,
          },
        ],
      },
    },
    {
      path: '/second-page',
      name: 'second-page',
      component: () => import('@/views/SecondPage.vue'),
      meta: {
        pageTitle: 'Second Page',
        breadcrumb: [
          {
            text: 'Second Page',
            active: true,
          },
        ],
      },
    },
    {
      path: '/activities',
      name: 'activities',
      component: () => import('@/views/Activities/index.vue'),
      meta: {
        pageTitle: 'Activity Mangament',
        breadcrumb: [
          {
            text: 'Activity Schedule',
            active: true,
          },
        ],
      },
    },
    {
      // Community admin notification centre. Open to every community,
      // including one whose trial ended (see allowedIfTrialExpired).
      path: '/notifications',
      name: 'notifications',
      component: () => import('@/views/Notifications/Index.vue'),
      meta: {
        pageTitle: 'Notifications',
        breadcrumb: [
          {
            text: 'Notifications',
            active: true,
          },
        ],
      },
    },
    {
      path: '/reports',
      name: 'reports',
      component: () => import('@/views/Reports/index.vue'),
      meta: {
        pageTitle: 'Reports',
        breadcrumb: [
          {
            text: 'Reports',
            active: true,
          },
        ],
      },
    },
    {
      path: '/attendance-management',
      name: 'attendanceManagement',
      component: () => import('@/views/AttendanceManagement/Index.vue'),
      meta: {
        pageTitle: 'Attendance Management',
        breadcrumb: [
          {
            text: 'Attendance Management',
            active: true,
          },
        ],
      },
    },
    {
      path: '/activity/:id',
      name: 'attendanceManagement',
      component: () => import('@/views/AttendanceManagement/Activity.vue'),
      meta: {
        pageTitle: 'Activity',
        breadcrumb: [
          {
            text: 'Attendance Management',
            active: true,
          },
        ],
      },
    },
    // ActivityAttendee
    {
      path: '/view-attendees/:id',
      name: 'attendanceManagement',
      component: () => import('@/views/AttendanceManagement/ViewAttendees.vue'),
      meta: {
        pageTitle: 'View Attendees',
        breadcrumb: [
          {
            text: 'View Attendees',
            active: true,
          },
        ],
      },
    },
    {
      path: '/activity-attendees/:id',
      name: 'ActivityAttendee',
      component: () => import('@/views/Activities/components/ActivityAttendees.vue'),
      meta: {
        pageTitle: 'View Attendees',
        breadcrumb: [
          {
            text: 'View Attendees',
            active: true,
          },
        ],
      },
    },
    {
      path: '/style',
      name: 'StyleGuide',
      component: () => import('@/views/StyleGuide.vue'),
      meta: {
        pageTitle: 'Style Guide',
        breadcrumb: [
          {
            text: 'Style Guide',
            active: true,
          },
        ],
      },
    },
    // {
    //   path: '/login',
    //   name: 'login',
    //   component: () => import('@/views/Login.vue'),
    //   meta: {
    //     layout: 'full',
    //   },
    // },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/components/login/Login.vue'),
      meta: {
        layout: 'full',
        // Phones get the picker in the page's own top bar instead of floating.
        inlineLanguageSwitcherOnPhone: true,
      },
    },
    {
      path: '/complete-profile-page',
      name: 'CompleteProfilePage',
      component: () => import('@/components/user-profile/complete-user-profile.vue'),
      meta: {
        layout: 'full',
        // HeaderSignup carries the picker on phones (see LayoutFull).
        inlineLanguageSwitcherOnPhone: true,
      },
    },
    {
      path: '/community-selection',
      name: 'CommunitySelection',
      component: () => import('@/components/community/community-selection.vue'),
      meta: {
        layout: 'full',
        // Phones get the picker in the page's own top bar instead of floating.
        inlineLanguageSwitcherOnPhone: true,
      },
    },
    {
      path: '/aws-cognito-social',
      name: 'SignupComponentSocialCognito',
      component: () => import('@/views/AwsCognitoSocial.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signup',
        // HeaderSignup carries the picker on phones (see LayoutFull).
        inlineLanguageSwitcherOnPhone: true,
      },
    },
    {
      path: '/signup',
      name: 'signup',
      component: () => import('@/views/Signup/SignupComponent.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signup',
        // HeaderSignup carries the picker on phones (see LayoutFull).
        inlineLanguageSwitcherOnPhone: true,
      },
    },
    {
      path: '/forgot-password',
      name: 'ForgotPassword',
      component: () => import('@/components/forgot-password/forgot-password.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signup',
      },
    },
    {
      path: '/create-community',
      name: 'CreateCommunity',
      component: () => import('@/components/community/community-registration.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signup',
        // The page puts the language picker in its own header.
        hideLanguageSwitcher: true,
      },
    },
    {
      path: '/signup-social',
      name: 'SignupComponentSocial',
      component: () => import('@/views/Signup/SignupComponent.vue'),
      meta: {
        layout: 'full',
        pageTitle: 'Signup',
        // HeaderSignup carries the picker on phones (see LayoutFull).
        inlineLanguageSwitcherOnPhone: true,
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        // Reached from inside the dashboard, so it wears the community's
        // accent rather than the sign-in pages' fixed brand look (App.vue).
        followsAccent: true,
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

router.beforeEach((to, _, next) => {
  const unProtectedRoutes = [
    'login',
    'signup',
    'SignupComponentSocialCognito',
    'SignupComponentSocial',
    'ForgotPassword',
  ]

  const isLoggedIn = localStorage.getItem('token')
  const loginToken = localStorage.getItem('loginToken')
  CONSTANT.storeUTMParams();
  const utmParams = CONSTANT.storedUTMParams();
  const query = { ...to.query, ...utmParams };
  if (!unProtectedRoutes.includes(to.name) && !isLoggedIn) {
    return next({ ...to,name: 'login', query:  query})
  }
  if (to.name === 'CommunitySelection') {
    localStorage.setItem('token', loginToken)
  }

  if(utmParams && utmParams.utm_source && utmParams.utm_medium && utmParams.utm_campaign && window.gtag) {
    window.gtag('set', 'campaign_source', utmParams.utm_source);
    window.gtag('set', 'campaign_medium', utmParams.utm_medium);
    window.gtag('set', 'campaign_name', utmParams.utm_campaign);
  }
  const userData = JSON.parse(localStorage.getItem('userData'))
  const isPremium = userData?.isPremium ?? null
  const allowedIfTrialExpired = [
    'home',
    'CommunitySelection',
    'login',
    'signup',
    'SignupComponentSocialCognito',
    'SignupComponentSocial',
    'ForgotPassword',
    'CreateCommunity',
    'acceptTeamInvite',
    'notifications',
  ]
  const isAllowedRoute = allowedIfTrialExpired.includes(to.name)
  || (to.name === 'setting' && to.hash === '#billing') || (to.name === 'setting' && to.hash === '#subscription')||
  // Notification settings stay reachable for a community whose trial ended.
  (to.name === 'setting' && to.hash === '#notifications') ||
  to.path.startsWith('/accept-team-invite');
  
  if (!isPremium && !isAllowedRoute) {
    if (to.name !== 'home') {
      return next({ name: 'home' });
    } else {
      return next(false);
    }
  }
  if (Object.keys(query).length !== Object.keys(to.query).length) {
    next({
      path: to.path,
      query: query
    });
  } else {
    next();
  }

})

export default router
